import { useStatQuery } from '@famly/stat_use-stat-query';
import { StatPermissionsRatioInfo } from './stat-permissions-ratio-info.query';
export function useStatPermissionsRatioInfoQuery(options) {
    return useStatQuery(StatPermissionsRatioInfo, options);
}
